import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import {
  PostFuelType,
  UpdateFuelType,
  GetMasterCompany,
  PaidWallet,
  ReceivedWallet,
  GetBookingCode,
  GetSubBookingCode,
} from "../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import dayjs from "dayjs";
import { Box } from "@mui/material";

const ReceivedTransaction = (props) => {
  const UserId = sessionStorage.getItem("UserId");

  const {
    selectedData,
    GetData,
    setOpenPaidTransaction,
    GetUserWalletDetails,
    PaidUserName,
    functionType,
    onSubmit,
    formRef
  } = props;

  const initialValues = {
    walletCompanyId: "",
    amount: "",
    TDS: "",
    transactionDate: new Date(),
    bookingCodeId: "",
    subBookingCodeId: "",
    TDSamount: "",
    TransferAmount: "",
  };

  const [companyDetails, setCompanyDetails] = useState([]);

  const [withTDS, setWithTDS] = useState(false);

  // const onSubmit = (e) => {
  //   e.isCommisionRecievable = true;
  //   const RandomNumber = Math.floor(Math.random() * 9000000000) + 1000000000;
  //   e.userId = selectedData.userId;
  //   e.policyNumber = RandomNumber.toString();
  //   e.status = "WALLET";
  //   e.withTDS = false;
  //   e.bookingCodeId = selectedData?.bookingCodeId;
  //   e.subBookingCodeId = selectedData?.subBookingCodeId;
  //   // e.paymentMode = functionType === "Paid" ? "PAID" : "RECEIVED"
  //   e.createdBy = UserId;
  //   ReceivedWallet(e)
  //     .then((res) => {
  //       console.log(res);
  //       GetData();
  //       GetUserWalletDetails();
  //       setOpenPaidTransaction(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const GetCompanyDetails = () => {
    GetMasterCompany().then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.masterCompanyName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  React.useEffect(() => {
    GetCompanyDetails();
  }, []);

  const styles = {
    box: {
      border: "1px solid #ccc",
      borderRadius: "8px",
      backgroundColor: "#fff",
    },
    label: {
      fontSize: "12px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
    },
    head: {
      fontSize: "14px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
    },
  };

  return (
    <>
      <div style={{ padding: "20px" }}>
        <Grid container>
          <Grid item xs={6} sm={11}>
            <Typography sx={styles.head}>
              Received to {selectedData?.[0].bookingCode} -{" "}
              {selectedData?.[0].subBookingCode}
            </Typography>
          </Grid>
        </Grid>
        <div>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            innerRef={formRef}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Grid container rowSpacing={1}>
                  <Grid item xs={12} sm={12} mt={2}>
                    <label style={styles.label}>Transaction Date</label>
                    <Box sx={styles.box}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          name="transactionDate"
                          className="w-100"
                          format="DD/MM/YYYY"
                          onChange={(e) =>
                            setFieldValue("transactionDate", e.$d)
                          }
                          defaultValue={dayjs()}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <label style={styles.label}>Bank</label>
                    <Field
                      name="bank"
                      className="InputFiled"
                      style={{
                        textTransform: "uppercase",
                        width: "100%",
                        padding: "8px",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <label style={styles.label}>Remarks</label>
                    <Field
                      name="remarks"
                      className="InputFiled"
                      style={{
                        textTransform: "uppercase",
                        width: "100%",
                        padding: "8px",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <label style={styles.label}>Select Company</label>
                    <Box sx={styles.box}>
                      <Autocomplete
                        name="walletCompanyId"
                        disablePortal
                        id="combo-box-demo"
                        onChange={(e, v) =>
                          setFieldValue("walletCompanyId", v?._id)
                        }
                        options={companyDetails}
                        clearIcon={false}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <label style={styles.label}>Amount</label>
                    <TextField
                      name="amount"
                      className="InputFiled"
                      onChange={(e) => setFieldValue("amount", e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default ReceivedTransaction;
